import { end, type End } from './end';
import { next, type Next } from './next';

export const actions = {
	end,
	next,
} as const;

export type StoreActions = typeof actions;

export type Actions = {
	end: End;
	next: Next;
};
